import { Pipe, PipeTransform } from '@angular/core';
import { SurveyElementType } from '../models/submissions/submission-list-item.model';

type RGBA = { r: number; g: number; b: number; a: number };

type ColorSet = {
  background: RGBA;
  font: RGBA;
};

@Pipe({
  name: 'colorPipe',
})
export class ColorPipe implements PipeTransform {
  private positiveColor: ColorSet = {
    background: { r: 217, g: 227, b: 220, a: 0.5 },
    font: { r: 94, g: 122, b: 113, a: 1 },
  };

  private middleColor: ColorSet = {
    background: { r: 242, g: 225, b: 198, a: 0.5 },
    font: { r: 176, g: 120, b: 16, a: 1 },
  };

  private negativeColor: ColorSet = {
    background: { r: 243, g: 223, b: 222, a: 0.5 },
    font: { r: 171, g: 86, b: 87, a: 1 },
  };

  transform(value: number, type: SurveyElementType): { background: string; font: string } {
    let colorSet: ColorSet;

    if (type === SurveyElementType.SingleSelect || type === SurveyElementType.MultiSelect) {
      if (value == 0) {
        colorSet = this.positiveColor;
      } else if (value == 1 || value == 2) {
        colorSet = this.middleColor;
      } else if (value == 3 || value == 4) {
        colorSet = this.negativeColor;
      } else {
        colorSet = this.positiveColor;
      }
    } else if (type === SurveyElementType.SingleSelectSlider || type === SurveyElementType.Number) {
      if (value >= 0 && value <= 4) {
        colorSet = this.positiveColor;
      } else if (value === 5) {
        colorSet = this.middleColor;
      } else if (value >= 6 && value <= 10) {
        colorSet = this.negativeColor;
      } else {
        colorSet = this.positiveColor;
      }
    } else {
      colorSet = this.positiveColor;
    }

    return {
      background: this.getColorString(colorSet.background),
      font: this.getColorString(colorSet.font),
    };
  }

  private getColorString(color: RGBA): string {
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
  }
}
